import { type EditorView } from '@progress/kendo-editor-common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useToggle } from 'react-use'

import { StyledButton } from '~/components/elements/StyledButton'

import { InsertDocumentImageDialog } from './InsertDocumentImageDialog'

export type InsertDocumentImageToolProps = {
  view: EditorView
}

export const InsertDocumentImageTool = ({
  view,
}: InsertDocumentImageToolProps) => {
  const [isDialogVisible, toggleIsDialogVisible] = useToggle(false)
  const { t } = useTranslation()

  return (
    <>
      <StyledButton fillMode="outline" onClick={toggleIsDialogVisible}>
        {t('insert_saved_table_graph')}
      </StyledButton>

      {isDialogVisible && (
        <InsertDocumentImageDialog
          view={view}
          onClose={toggleIsDialogVisible}
        />
      )}
    </>
  )
}
